import React from "react";
import Link from "@/components/LocalizedLink";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

const HERO_IMG = "/hero-bag.jpg";

const Hero = () => {
  const { t } = useTranslation();
  return (
    <section
      id="home"
      className="relative isolate overflow-hidden"
      style={{ minHeight: "min(90vh, 760px)" }}
      data-testid="hero"
    >
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_IMG}
          alt={t("hero.imageAlt")}
          className="h-full w-full object-cover"
          style={{ objectPosition: "center 45%" }}
          loading="eager"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      {/* Trust badge — Custodi della Tradizione (top-right) */}
      <div className="absolute top-6 sm:top-8 right-4 sm:right-8 z-10 flex flex-row items-center gap-3 sm:gap-4 pointer-events-none">
        <img
          src="/badge-custodi.png"
          alt="Custodi della Tradizione — 2ª Generazione"
          className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 object-contain drop-shadow-[0_6px_18px_rgba(0,0,0,0.55)] hero-badge"
          loading="eager"
          data-testid="hero-badge-custodi"
        />
      </div>

      <div
        className="relative max-w-5xl mx-auto px-6 lg:px-8 flex flex-col items-center justify-center text-center"
        style={{ minHeight: "min(90vh, 760px)", paddingTop: 96, paddingBottom: 96 }}
      >
        <span
          className="rise-in font-serif-display uppercase tracking-[0.35em] text-xs sm:text-sm mb-6"
          style={{ color: "#ecdcbd" }}
          data-testid="hero-eyebrow"
        >
          {t("hero.eyebrow")}
        </span>
        <h1
          className="rise-in d1 font-serif-display text-white font-bold leading-[1.05]"
          style={{ fontSize: "clamp(2rem, 5.4vw, 4.5rem)", textShadow: "0 4px 24px rgba(0,0,0,0.55)" }}
          data-testid="hero-title"
        >
          {t("hero.title1")}
          <br />
          <span style={{ color: "#f5ead6" }}>{t("hero.title2")}</span>
        </h1>
        <div className="rise-in d2 mt-6 flex items-center gap-4">
          <span className="h-px w-12" style={{ background: "#c5371f" }} />
          <p
            className="font-serif-display text-2xl sm:text-3xl font-semibold"
            style={{ color: "#fbf5e9", letterSpacing: "0.12em" }}
          >
            {t("hero.dal")}
          </p>
          <span className="h-px w-12" style={{ background: "#c5371f" }} />
        </div>
        <p
          className="rise-in d2 mt-6 max-w-2xl text-base sm:text-lg"
          style={{ color: "#fbf5e9", opacity: 0.92 }}
          data-testid="hero-subtitle"
        >
          {t("hero.subtitle")}
        </p>
        <div className="rise-in d3 mt-10 flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
          <Link
            to="/le-origini"
            className="btn-red focus-ring inline-flex items-center justify-center px-8 py-3.5 rounded-full font-semibold uppercase tracking-wider text-sm"
            data-testid="hero-cta-origini"
          >
            {t("hero.ctaOrigini")}
          </Link>
          <Link
            to="/nel-tempo"
            className="btn-outline-cream focus-ring inline-flex items-center justify-center px-8 py-3.5 rounded-full font-semibold uppercase tracking-wider text-sm"
            data-testid="hero-cta-tempo"
          >
            {t("hero.ctaStoria")}
          </Link>
        </div>

        {/* Scroll cue */}
        <a
          href="#brand-intro"
          aria-label={t("hero.scrollDown")}
          className="absolute bottom-6 inset-x-0 flex justify-center text-white/80 hover:text-white transition"
        >
          <ChevronDown size={28} className="animate-bounce" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
